import { FunctionComponent } from "react";
import { EntityList } from "../EntityList/EntityList";
import { EntityListActionBar } from "../EntityListActions/EntityListActionBar";
import { useAppSelector } from "@store/store";
import { Plan } from "../../plan/Plan/Plan";
import { selectIsDisableLists } from "@store/client/clientReducer";
import { useMatch } from "react-router";
import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";
import { selectIsHeaderVisible } from "@store/app/appReducer";

import "./EntityListContainer.css";

const EntityListContainer: FunctionComponent = () => {
  const isHeaderVisible = useAppSelector(selectIsHeaderVisible);
  const isDisableLists = useAppSelector(selectIsDisableLists);
  const isPlanScreen = useMatch("/plan");
  const { isMobile } = useWindowSize();

  if (isDisableLists || isMobile) {
    return null;
  }

  return (
    <div
      className={`${
        isPlanScreen || !isHeaderVisible
          ? "entity-list-container-component hide-menu-items"
          : "entity-list-container-component"
      } ${isMobile ? "mobile" : ""}`}>
      {isPlanScreen ? (
        <Plan />
      ) : (
        <>
          <EntityListActionBar />
          <EntityList />
        </>
      )}
    </div>
  );
};

export { EntityListContainer };
